import { render } from "./ActionSendDocumentsEditor.vue?vue&type=template&id=1653cc64&scoped=true"
import script from "./ActionSendDocumentsEditor.vue?vue&type=script&lang=js"
export * from "./ActionSendDocumentsEditor.vue?vue&type=script&lang=js"

import "./ActionSendDocumentsEditor.vue?vue&type=style&index=0&id=1653cc64&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1653cc64"]])

export default __exports__